import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem, Select } from '@material-ui/core';

import { selectInputHandler } from './input.helpers';

const toMenuItemProps = ({ id, className, label, value }, { disabled }) => ({
	id,
	className,
	disabled,
	key: value,
	label,
	value,
});

const SelectWidget = props => {
	const { onChange, options, style, placeholder, ...otherProps } = props;
	const handler = selectInputHandler(onChange);
	return (
		<Select color="primary" onChange={handler} style={style} {...otherProps}>
			{placeholder && (
				<MenuItem value="" disabled>
					{placeholder || ''}
				</MenuItem>
			)}
			{options &&
				options.map(option => {
					return (
						<MenuItem {...toMenuItemProps(option, otherProps)}>
							{option.label}
						</MenuItem>
					);
				})}
		</Select>
	);
};

SelectWidget.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.func,
	options: PropTypes.array,
};

export default SelectWidget;
